import {
  CalendarEventDetails,
  CalendarEventResponseStatus,
  ConnectionCalendar,
  ExternalCalendarEventPreview,
  ExternalConnection,
} from '@griply/types';

import {
  ExternalEventEditableTarget,
  getExternalEventEditable,
} from './get-external-event-editable';

export type GetCalendarEventInvitationOptions = {
  details?: CalendarEventDetails | null;
  preview?: ExternalCalendarEventPreview | null;
  target: ExternalEventEditableTarget;
  connections: ExternalConnection[];
  calendars: ConnectionCalendar[];
};

export type CalendarEventInvitation = {
  responseStatus?: CalendarEventResponseStatus | null;
  hasInvitation: boolean;
  isInvitee: boolean;
};

export const getCalendarEventInvitation = ({
  details,
  preview,
  target,
  connections,
  calendars,
}: GetCalendarEventInvitationOptions): CalendarEventInvitation => {
  // not `??`: a resolved `null` is a real answer and would fall through to the list payload
  const responseStatus = details
    ? details.selfResponseStatus
    : preview?.selfResponseStatus;

  // a read-only calendar cannot take the write, whatever the backend says about the status
  const hasInvitation =
    responseStatus !== null &&
    getExternalEventEditable(target, { connections, calendars });

  // organisers fold to `accepted` server-side, so the organiser half is needed on top
  const isInvitee =
    (details?.isOrganizer ?? preview?.isOrganizer) === false && hasInvitation;

  return { responseStatus, hasInvitation, isInvitee };
};
